export default {
    'accepted': 'accepted|attribute=:attribute',
    'active_url': 'active_url|attribute=:attribute',
    'after': 'after|attribute=:attribute&date=:date',
    'after_or_equal': 'after_or_equal|attribute=:attribute&date=:date',
    'alpha': 'alpha|attribute=:attribute',
    'alpha_dash': 'alpha_dash|attribute=:attribute',
    'alpha_num': 'alpha_num|attribute=:attribute',
    'array': 'array|attribute=:attribute',
    'before': 'before|attribute=:attribute&date=:date',
    'before_or_equal': 'before_or_equal|attribute=:attribute&date=:date',
    'between': {
        numeric: 'between.numeric|attribute=:attribute&min=:min&max=:max.',
        file: 'between.file|attribute=:attribute&min=:min&max=:max',
        string: 'between.string|attribute=:attribute&min=:min&max=:max',
        array: 'between.array|attribute=:attribute&min=:min&max=:max',
    },
    'boolean': 'boolean|attribute=:attribute',
    'confirmed': 'confirmed|attribute=:attribute',
    'date': 'date|attribute=:attribute',
    'date_equals': 'date_equals|attribute=:attribute&date=:date',

    'date_format': 'date_format|attribute=:attribute&format=:format',
    'different': 'different|attribute=:attribute&other=:other',

    'digits': 'digits|attribute=:attribute',

    'digits_between': 'digits_between|attribute=:attribute&min=:min&max=:max',
    'dimensions': 'dimensions|attribute=:attribute',
    'distinct': 'distinct|attribute=:attribute',
    'email': 'email|attribute=:attribute',
    'ends_with': 'ends_with|attribute=:attribute&values=:values',
    'exists': 'exists|attribute=:attribute',
    'file': 'file|attribute=:attribute',
    'filled': 'filled|attribute=:attribute',
    'gt': {
        numeric: 'gt.numeric|attribute=:attribute&value=:value',
        file: 'gt.file|attribute=:attribute&value=:value',
        string: 'gt.string|attribute=:attribute&value=:value',
        array: 'gt.array|attribute=:attribute&value=:value',
    },
    'gte': {
        numeric: 'gte.numeric|attribute=:attribute&value=:value',
        file: 'gte.file|attribute=:attribute&value=:value',
        string: 'gte.string|attribute=:attribute&value=:value',
        array: 'gte.array|attribute=:attribute',
    },
    'image': 'image|attribute=:attribute',
    'in': 'in|attribute=:attribute',
    'in_array': 'in_array|attribute:attribute&other=:other',
    'integer': 'integer|attribute=:attribute',
    'ip': 'ip|attribute=:attribute',
    'ipv4': 'ipv4|attribute=:attribute',
    'ipv6': 'ipv6|attribute=:attribute',
    'json': 'json|attribute=:attribute',
    'lt': {
        numeric: 'lt.numeric|attribute=:attribute&value=:value.',
        file: 'lt.file|attribute=:attribute&value=:value',
        string: 'lt.string|attribute=:attribute&value=:value',
        array: 'lt.array|attribute=:attribute&value=:value',
    },
    'lte': {
        numeric: 'lte.numeric|attribute=:attribute&value=:value.',
        file: 'lte.file|attribute=:attribute&value=:value',
        string: 'lte.string|attribute=:attribute&value=:value',
        array: 'lte.array|attribute=:attribute&value=:value',
    },
    'max': {
        numeric: 'max.numeric|attribute=:attribute&max=:max',
        file: 'max.file|attribute=:attribute&max=:max',
        string: 'max.string|attribute=:attribute&max=:max',
        array: 'max.array|attribute=:attribute&max=:max',
    },
    'mimes': 'mimes|attribute=:attribute&values=:values',
    'mimetypes': 'mimetypes|attribute=:attribute&values=:values',
    'min': {
        numeric: 'min.numeric|attribute=:attribute&min=:min.',
        file: 'min.file|attribute=:attribute&min=:min',
        string: 'min.string|attribute=:attribute&min=:min',
        array: 'min.array|attribute=:attribute&min=:min',
    },
    'not_in': 'not_in|attribute=:attribute',
    'not_regex': 'not_regex|attribute=:attribute',
    'numeric': 'numeric|attribute=:attribute',
    'password': 'password|attribute=:attribute',
    'present': 'present|attribute=:attribute',
    'regex': 'regex|attribute=:attribute',
    'required': 'required|attribute=:attribute',
    'nullable': 'nullable|attribute=:attribute',
    'required_if': 'required_if|attribute=:attribute&other=:other&value=:value',
    'required_unless': 'required_unless|attribute=:attribute&other=:other&values=:values',
    'required_with': 'required_with|attribute=:attribute&values=:values',
    'required_with_all': 'required_with_all|attribute=:attribute&values=:values',
    'required_without': 'required_without|attribute=:attribute&values=:values',
    'required_without_all': 'required_without_all|attribute=:attribute&values=:values',
    'same': 'same|attribute=:attribute&other=:other',
    'size': {
        numeric: 'size.numeric|attribute=:attribute&size=:size',
        file: 'size.file|attribute=:attribute&size=:size',
        string: 'size.string|attribute=:attribute&size=:size',
        array: 'size.array|attribute=:attribute&size=:size',
    },
    'starts_with': 'starts_with|attribute=:attribute&values=:values',
    'string': 'string|attribute=:attribute',
    'timezone': 'timezone|attribute=:attribute',
    'unique': 'unique|attribute=:attribute',
    'uploaded': 'uploaded|attribute=:attribute',
    'url': 'url|attribute=:attribute',
    'uuid': 'uuid|attribute=:attribute',

    'plaintext': 'plaintext|attribute=:attribute',
    'discount': 'discount',
    'either_debit_or_credit': 'either_debit_or_credit',
    'positive_number': 'positive_number',
    '2mb_file': '2mb_file',
    'after_close_date': 'after_close_date',
    'in_pension_range': 'in_pension_range',
    'less_than_or_equal': 'less_than_or_equal|attribute=:attribute&value=:value',
    'inventory_available': 'inventory_available|attribute=:attribute&value=:value',
    'exact_non_cash_payment': 'exact_non_cash_payment|attribute=:attribute&value=:value',
    'cannot_be_less_than_balance': 'cannot_be_less_than_balance|attribute=:attribute&value=:value',
    'invalid.coupon': 'invalid.coupon|attribute=:attribute',
};
